// index.js
import "normalize.css";
import 'leaflet/dist/leaflet.css'; // LeafletのCSSをインポート
import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import "./i18n"; // i18nextの初期化
import App from "./App";
import { Box } from "@mui/material";

// Fallback for react-refresh runtime (avoids _s/$RefreshSig$ errors on HMR glitches)
if (typeof window !== "undefined") {
  if (!window.$RefreshSig$) {
    window.$RefreshSig$ = () => (type) => type;
  }
  if (!window.$RefreshReg$) {
    window.$RefreshReg$ = () => {};
  }
}

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  <Box sx={{ bgcolor: "black", minHeight: "100vh" }}>
    <React.StrictMode>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </React.StrictMode>
  </Box>
);
